import { ActionEventType, } from '@thoughtspot/ts-chart-sdk';
import Joi from 'joi';
const columnSortActionHandlerSchema = Joi.object({
    columnId: Joi.string().required(),
    isAscending: Joi.boolean().required(),
});
const actionHandlerEventPayloadSchema = Joi.object({
    eventType: Joi.string()
        .valid(...Object.values(ActionEventType))
        .required(),
    payload: columnSortActionHandlerSchema.required(),
}).unknown(false);
export const validateActionHandlerEventPayloadObject = (eventData) => {
    try {
        Joi.assert(eventData, actionHandlerEventPayloadSchema);
    }
    catch (err) {
        throw new Error(err.details[0].message);
    }
};
//# sourceMappingURL=utils.js.map